import Vue from 'vue';

import { fetchMetadata } from '@/services/okFormResource';
import * as enums from '@/services/fetchEnum';

const enumAction = (name, enumGetter) => ({ state, commit }) => {
  const enumData = state.enumData[name];
  let fetchPromise = state.promise[name];

  if (enumData) {
    fetchPromise = new Promise(resolve => resolve(enumData));
  } else if (!fetchPromise) {
    fetchPromise = enumGetter()
      .then(enumData => {
        commit('enumFetchDone', { name, enumData });
        return enumData;
      })
      .catch(err => {
        commit('enumFetchError', { name });
        Vue.notify({
          title: 'Server error',
          text: `Nepodařilo se načíst hodnoty číselníku. ${err && err.statusText}`,
          type: 'danger',
        });
      });

    commit('enumFetchStart', { name, fetchPromise });
  }

  return fetchPromise;
};

/**
 * @type {Vuex.Store}
 */
export default {
  state: {
    promise: {
      metadata: null,
      organizationType: null,
      country: null,
      titleBefore: null,
      titleAfter: null,
      jobInformationSource: null,
      howAppliedForJob: null,
      lastJob: null,
      pension: null,
      healthInsurance: null,
      document: null,
      sex: null,
      educationalAttainment: null,
      school: null,
      oborSpecializacnihoVzdelaniFarmaceutu: null,
      oborSpecializacnihoVzdelaniFarmaceutickychAsistentu: null,
      organizations: null,
      positionType: null,
      workTime: null,
      smennost: null,
      bank: null,
      documents: null,
    },
    enumData: {
      metadata: null,
      organizationType: null,
      country: null,
      titleBefore: null,
      titleAfter: null,
      jobInformationSource: null,
      howAppliedForJob: null,
      lastJob: null,
      pension: null,
      healthInsurance: null,
      document: null,
      sex: null,
      educationalAttainment: null,
      school: null,
      oborSpecializacnihoVzdelaniFarmaceutu: null,
      oborSpecializacnihoVzdelaniFarmaceutickychAsistentu: null,
      organizations: null,
      positionType: null,
      workTime: null,
      smennost: null,
      bank: null,
      documents: null,
    },
  },
  mutations: {
    enumFetchStart(state, { name, fetchPromise }) {
      state.enumData[name] = null;
      state.promise[name] = fetchPromise;
    },
    enumFetchDone(state, { name, enumData }) {
      state.enumData[name] = enumData;
      state.promise[name] = null;
    },
    enumFetchError(state, { name }) {
      state.enumData[name] = null;
      state.promise[name] = null;
    },
  },
  actions: {
    metadata: enumAction('metadata', fetchMetadata),
    organizationTypeEnum: enumAction('organizationType', enums.organizationTypeEnum),
    countryEnum: enumAction('country', enums.countryEnum),
    titleBeforeEnum: enumAction('titleBefore', enums.titleBeforeEnum),
    titleAfterEnum: enumAction('titleAfter', enums.titleAfterEnum),
    jobInformationSourceEnum: enumAction('jobInformationSource', enums.jobInformationSourceEnum),
    howAppliedForJobEnum: enumAction('howAppliedForJob', enums.howAppliedForJobEnum),
    lastJobEnum: enumAction('lastJob', enums.lastJobEnum),
    pensionEnum: enumAction('pension', enums.pensionEnum),
    healthInsuranceEnum: enumAction('healthInsurance', enums.healthInsuranceEnum),
    sexEnum: enumAction('sex', enums.sexEnum),
    educationalAttainmentEnum: enumAction('educationalAttainment', enums.educationalAttainmentEnum),
    schoolEnum: enumAction('school', enums.schoolEnum),
    oborSpecializacnihoVzdelaniFarmaceutuEnum: enumAction(
      'oborSpecializacnihoVzdelaniFarmaceutu',
      enums.oborSpecializacnihoVzdelaniFarmaceutuEnum
    ),
    oborSpecializacnihoVzdelaniFarmaceutickychAsistentuEnum: enumAction(
      'oborSpecializacnihoVzdelaniFarmaceutickychAsistentu',
      enums.oborSpecializacnihoVzdelaniFarmaceutickychAsistentuEnum
    ),
    organizationsEnum: enumAction('organizations', enums.organizationsEnum),
    positionTypeEnum: enumAction('positionType', enums.positionTypeEnum),
    workTimeEnum: enumAction('workTime', enums.workTimeEnum),
    smennostEnum: enumAction('smennost', enums.smennostEnum),
    bankEnum: enumAction('bank', enums.bankEnum),
    groupedDocuments: enumAction('documents', enums.documentsDefinition),
  },
};
